import React from 'react'
import PropTypes from 'prop-types'
import { Element } from 'react-scroll'

import * as reactUtil from '../../util/react'

import styles from './element-wrapper.module.css'

const propTypes = {
    containerId: PropTypes.string,
    element: PropTypes.element.isRequired,
    index: PropTypes.number.isRequired
}

/**
 * ElementWrapper to wrap every children of a table of contents.
 *
 * @param {ReactElement} element - The child which will be wrapped
 * @param {number} index - Index Number for the current Element
 * @returns {ReactElement}
 */
const ElementWrapper = props => {
    const { containerId, element, index } = props
    const { name } = element.props

    const additionalProps = reactUtil.getExtraneousProps(propTypes, props) || {}
    additionalProps.key = index
    additionalProps.containerId = containerId

    return (
        <Element name={name} className={styles['element']}>
            {React.cloneElement(element, additionalProps)}
        </Element>
    )
}

ElementWrapper.propTypes = propTypes

export default ElementWrapper
